module.exports = __webpack_public_path__ + "img/mobile_head.8c9dc59c.png";